import React from 'react'
import Link from 'gatsby-link'
import { Tooltip } from '@material-ui/core'
import ImplantIcon from 'components/icons/Implant'
import BondingIcon from 'components/icons/Bonding'
import CrownIcon from 'components/icons/Crown'
import BridgesIcon from 'components/icons/Bridges'
import VeneerIcon from 'components/icons/Veneer'
import DenturesIcon from 'components/icons/Dentures'
import XRayIcon from 'components/icons/XRay'
import FillingIcon from 'components/icons/Filling'
import HygieneIcon from 'components/icons/Hygiene'
import PeriodontalIcon from 'components/icons/Periodontal'
import WisdomTeethIcon from 'components/icons/WisdomTeeth'
import WhiteningIcon from 'components/icons/Whitening'
import RootCanalIcon from 'components/icons/RootCanal'
import dentalKit from 'static/dental-kit.jpg'

const TreatmentIconContainer = ({ children, label }) => (
  <Tooltip title={label} aria-label={label}>
    <Link to="/treatments">
      <div
        className="flex items-center justify-center w-14 h-14 rounded-xl bg-offWhite border border-grey transition-all duration-200 hover:bg-white hover:shadow-md hover:border-primary hover:scale-105"
        style={{ margin: '4px' }}
      >
        {children}
      </div>
    </Link>
  </Tooltip>
)

const TreatmentsSection = () => (
  <section className="py-24 px-6 bg-offWhite">
    <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row items-center gap-16">
        {/* Content Side */}
        <div className="flex-1 text-center lg:text-left">
          {/* Section Badge */}
          <div
            className="inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-6"
            style={{
              background:
                'linear-gradient(135deg, rgba(99, 91, 255, 0.1) 0%, rgba(17, 239, 227, 0.1) 100%)',
              color: '#635bff'
            }}
          >
            Comprehensive Care
          </div>

          <h2 className="text-4xl font-bold text-navy mb-4">
            Services We Offer
          </h2>
          <p className="text-lg text-textSecondary leading-relaxed mb-8 max-w-lg">
            From routine cleanings to advanced procedures, we provide a complete
            range of dental treatments to keep your smile healthy and beautiful.
          </p>

          {/* Treatment Icons Grid */}
          <div className="flex flex-wrap justify-center lg:justify-start mb-8">
            <TreatmentIconContainer label="Bonding">
              <BondingIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Implant">
              <ImplantIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Crown">
              <CrownIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Bridges">
              <BridgesIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Veneer">
              <VeneerIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Dentures">
              <DenturesIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="X-Ray">
              <XRayIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Filling">
              <FillingIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Hygiene">
              <HygieneIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Periodontal">
              <PeriodontalIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Wisdom Teeth">
              <WisdomTeethIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Whitening">
              <WhiteningIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
            <TreatmentIconContainer label="Root Canal">
              <RootCanalIcon size="1.5rem" color="primary" fill="primary" />
            </TreatmentIconContainer>
          </div>

          <Link
            to="/treatments"
            className="inline-flex items-center px-6 py-3 bg-primary text-white font-semibold text-sm rounded-lg transition-all duration-150 hover:bg-primaryDark"
            style={{
              boxShadow: '0 4px 14px 0 rgba(99, 91, 255, 0.39)'
            }}
          >
            View All Treatments
            <svg
              className="w-4 h-4 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div>

        {/* Image Side */}
        <div className="flex-1">
          <div
            className="relative rounded-2xl overflow-hidden"
            style={{
              boxShadow: '0 25px 50px -12px rgba(50, 50, 93, 0.25)'
            }}
          >
            <img
              className="w-full h-auto"
              src={dentalKit}
              alt="Modern dental equipment"
            />
            {/* Gradient overlay */}
            <div
              className="absolute inset-0 opacity-20"
              style={{
                background:
                  'linear-gradient(135deg, #635bff 0%, transparent 50%)'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default TreatmentsSection
